<template>
  <div>
    <div class="row" v-for="(name,idx) in dataArr" :key="idx">
      <div class="col-1">
        <label for="name">{{ idx }}</label>
      </div>
      <div class="col-7">
        <div class="form-group">
          <input class="form-control discountLbl" :id="'name-' + idx" v-model="dataArr[idx]" @keyup="updateCF()"/>
        </div>
      </div>
      <div class="col-4">
        <button class="btn btn-danger" @click="deleteCF(idx)">
          <span class="spinner-border spinner-border-sm spinDel d-none" :id="'spinnerSP_'+idx" role="status" aria-hidden="true"></span>
          Delete
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-primary" @click="addCF">
          <span class="spinner-border spinner-border-sm spinAdd d-none" id="spinnerAdd" role="status" aria-hidden="true"></span>
          Add
          </button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "ColorFamily",
  data() {
    return {
      dataArr: []
    };
  },
  emits: {
    updateColorFamily: null
  },
  computed: {
    ...mapGetters({
      'colorFamilyData': 'product/getColorFamilyData',
    }),

  },
  methods: {
    addCF() {
      document.querySelector('#spinnerAdd').classList.remove('d-none');
      this.$store.dispatch('product/addColorFamily',{name:'*******'}).then(rez => {
        this.dataArr[rez.id] = rez.name
        this.$emit('updateColorFamily', this.dataArr)
        document.querySelector('#spinnerAdd').classList.add('d-none');
      })
    },
    deleteCF(id) {
      document.querySelector('#spinnerSP_'+id).classList.remove('d-none');
      this.$store.dispatch('product/deleteColorFamily',{id}).then(rez => {
        if(rez.success) {
          delete this.dataArr[id]
          this.$emit('updateColorFamily', this.dataArr)
        }
        document.querySelector('#spinnerSP_'+id).classList.add('d-none');
      })
    },
    updateCF() {
      this.$emit('updateColorFamily', this.dataArr)
    },
  },
  mounted() {
    this.dataArr = this.colorFamilyData
    this.$store.dispatch('product/getColorFamily').then(() => {
      this.dataArr = this.colorFamilyData
      this.$emit('updateColorFamily', this.dataArr)
    })
  }
};
</script>
<style scoped>

.spinDel{
  position: absolute;
  left:35px;
  top:10px;
}

.spinAdd{
  position: absolute;
  top:10px;
}

</style>